import { Col, Row } from 'antd';
import { theme } from 'configs/styled';
import React from 'react';

export interface IDriverPortalLayout {}

const DriverPortalLayout: React.FC<IDriverPortalLayout> = props => {
  const { children } = props;

  return (
    <>
      <Row
        style={{
          background: theme.palettes.lightGrayWhite,
          minHeight: '100vh',
          padding: theme.spacing.md,
          fontFamily: `${theme.fonts.NotoSands}, ${theme.fonts.NotoSansTh}`,
          paddingTop: theme.spacing.xl,
          paddingBottom: theme.spacing.xxxxl,
        }}
      >
        <Col xs={0} sm={3} md={6} lg={7} xl={8} xxl={9} />
        <Col xs={24} sm={15} md={12} lg={10} xl={8} xxl={6}>
          {children}
        </Col>
        <Col xs={0} sm={3} md={6} lg={7} xl={8} xxl={9} />
      </Row>
    </>
  );
};

export default DriverPortalLayout;
